import axios from 'axios';
import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";

const FaqScroll = (props) => {
    const [nftData, setNftData] = useState([]);
    const colorString = Object.values(props.theme).toString();
    useEffect(() => {
        axios.get('https://appi.colexion.io/api/Blog/nft').then(res => {
            setNftData(res.data)
        });
    }, [])
    console.log(nftData);
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
              }
            }

          ]
    };
    return (
        <section className={colorString === 'true'?`faqScroll customSec dark`: `faqScroll customSec whiteTheme`}>
            <div className="container">
                <div className="scroller">
                    <div className="sectionHeading justify-content-center text-center">
                        <div className="d-block">
                            <h2>KNOW ALL ABOUT NFTS</h2>
                            <h3>Become familiar with NFTs from scratch </h3>
                        </div>
                    </div>
                    <Slider {...settings}>
                        {nftData.map(nft => (
                            <div className="faqSlide" key={nft._id}>
                                <Link to={`/blog-detail/${nft._id}`}>
                                    <div className="faqSlideContent">
                                        <h3>{nft.title}</h3>
                                        <p dangerouslySetInnerHTML={{ __html: nft.content }}></p>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    )
}
export default FaqScroll;